import React from 'react';
import './App.css';
import { CLOTHING } from './clothing.js'

class App extends React.Component {
  state = {
    weather: null
  }
  componentDidMount() {
    this.getWeatherData()
    //navigator.geolocation.getCurrentPosition((position) => this.getWeatherData(position), (error) => console.log(error))
  }

  render() {
    const { weather } = this.state
    if (this.state.showWelcome) {
      return (
        <div onClick={() => this.setState({ showWelcome: !this.state.showWelcome })} class="page-welcome">
          <h1>Dress.Me</h1>
          <h2>By Ameya Sindgikar, Drew Warkentin, Fergie Galeromeloe, Cohen Sodhi</h2>
          <h4>Helping Newcomers Prepare for Canadian Weather </h4>
        </div>
      )
    }
    else if (!this.state.weather) {
      return <h2>Loading...</h2>;
    } else {
      const currentTemperature = this.convertFairenheightToCelcius(weather.currently.apparentTemperature)
      const clothingToWear = this.findClothingToWear(currentTemperature)
      const iconName = this.state.weather.currently.icon
      return (
        <div className="app">
          <div className="logo" onClick={() => this.setState({ showWelcome: !this.state.showWelcome })}>DRESS.ME</div>
          <div className="weather-card">
            <h2 className="city-name">Toronto, ON</h2>
            <h2 className="temperature">{currentTemperature} °C</h2>
            <img className="icon" src={`./icons/${iconName}.png`}></img>

            <div className="additional-details-container">
              <div className="detail-wrapper">
                <div className="detail-title">Chance of rain</div>
                <div className="detail-text">{this.state.weather.currently.precipProbability}%</div>
              </div>
              <div className="detail-wrapper">
                <div className="detail-title">Wind Speed</div>
                <div className="detail-text">{this.state.weather.currently.windSpeed} km/h</div>
              </div>
              <div className="detail-wrapper">
                <div className="detail-title">UV index</div>
                <div className="detail-text">{this.state.weather.currently.uvIndex}</div>
              </div>
              <div className="detail-wrapper">
                <div className="detail-title">Humidity</div>
                <div className="detail-text">{this.state.weather.currently.humidity}%</div>
              </div>

            </div>
          </div>


          <div className="clothing-card">
            <div>
              <h2>Today you should wear:</h2>
              <img src={`./icons/body.png`}></img>
            </div>
            <div className="clothing-info">
              <h3 className="head">{clothingToWear.head.text}</h3>
              <h3 className="torso">{clothingToWear.body.text}</h3>
              <h3 className="legs">{clothingToWear.legs.text}</h3>
              <h3 className="hands">{clothingToWear.hands.text}</h3>
              <h3 className="feet">{clothingToWear.feet.text}</h3>
              <h3>{clothingToWear.risks.text}</h3>
            </div>
          </div>
        </div>
      )
    }
  }

  convertFairenheightToCelcius(degrees) {
    return Math.round((degrees - 32) * .5556)
  }
  getWeatherData(position = { coords: {} }) {
    const lat = position.coords.latitude || 43.6532
    const long = position.coords.longitude || -79.3832

    fetch(`https://cors-anywhere.herokuapp.com/https://api.darksky.net/forecast/80c82688a1f6d38c0429dcfcf4e0da0f/${lat},${long}`)
      .then((response) => {
        return response.json();
      }).then((weatherJSON) => {
        this.setState({ weather: weatherJSON })
      })
  }

  findClothingToWear(temperature) {
    if (temperature <= -25) {
      return <div>{CLOTHING['veryCold']}</div>
    } else if (temperature >= -24 && temperature <= 0) {
      return CLOTHING['cold']
    } else if (temperature >= 1 && temperature < 10) {
      return CLOTHING['warm']
    } else if (temperature >= 11 && temperature < 25) {
      return CLOTHING['hot']
    } else {
      return CLOTHING['veryHot']
    }
  }


}


export default App;
